import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPalette, faHeart, faStar } from "@fortawesome/free-solid-svg-icons";
import "./About.css";

function About() {
  return (
    <section className="about" id="about">
      <div className="container">
        <h2 className="section-title">O nama</h2>
        <div className="about-content">
          <div className="about-image-container">
            <div className="about-image-wrapper">
              <img
                src="/assets/img/marina.jpg"
                alt="Marina Bogdanić"
                className="about-image"
              />
              <div className="about-decoration">
                <FontAwesomeIcon icon={faPalette} className="decoration-icon" />
              </div>
            </div>
          </div>

          <div className="about-text">
            <h3 className="about-subtitle">Marina Bogdanić</h3>
            <p className="about-role">
              Umjetnica, modna dizajnerica i edukantica art terapije
            </p>

            <div className="about-description">
              <p>
                <FontAwesomeIcon icon={faHeart} className="about-icon" />
                Oduvijek sam vjerovala da umjetnost liječi. Kad crtamo, slikamo
                ili miješamo boje, zapravo razgovaramo sami sa sobom, nježno i
                bez riječi.
              </p>

              <p>
                <FontAwesomeIcon icon={faStar} className="about-icon" />
                Kroz svoje stvaranje, i kroz rad s djecom, naučila sam koliko je
                boja iskrena: dijete nikada ne laže u crtežu. Njegova mašta zna
                točno što mu treba — prostor, vrijeme i netko tko vjeruje u
                njega.
              </p>

              <p>
                Art&Fun Club kao dio BabyZooGardena je nastao iz te vjere i iz
                želje da svako dijete, u sigurnom i toplom okruženju, može
                slobodno istraživati, stvarati i izražavati se.
              </p>

              <p>
                U mom svijetu nema "pogrešnih crteža" ni "nespretnih poteza" —
                postoji samo proces, osmijeh i trenutak kad se boja pretvori u
                priču.
              </p>

              <p className="about-quote">
                <em>
                  "Vjerujem da kroz umjetnost djeca ne samo da stvaraju slike,
                  već grade povjerenje, pažnju i unutarnju ravnotežu. Umjetnost
                  nije samo moj posao, to je moj način gledanja svijeta."
                </em>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
